import { Injectable, inject, computed } from '@angular/core';
import { OrganService } from './organ.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  private readonly organService = inject(OrganService);

  readonly grantedPermissions = computed(() => {
    return this.organService.selectedOrgan()?.granted_permissions ?? [];
  });

  readonly isAdmin = computed(() => {
    return this.organService.selectedOrgan()?.is_admin_user ?? false;
  });

  hasPermission(permission: string): boolean {
    if (this.isAdmin()) {
      return true;
    }
    return this.grantedPermissions().includes(permission);
  }

  hasAnyPermission(permissions: string[]): boolean {
    if (this.isAdmin()) {
      return true;
    }
    return permissions.some((permission) =>
      this.grantedPermissions().includes(permission)
    );
  }

  hasAllPermissions(permissions: string[]): boolean {
    if (this.isAdmin()) {
      return true;
    }
    return permissions.every((permission) =>
      this.grantedPermissions().includes(permission)
    );
  }

  hasOrganizationFormsAccess(): boolean {
    return this.isAdmin() || this.hasPermission('a1b2c3d4'); // VIEW_CHARITY_PROFILE
  }
}
